import styled from 'styled-components';

export const Main = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  background-color: ${({ theme }) => theme.colors.background};
  grid-gap: 20px;
  padding: 8px 45px;

  @media (max-width: 767px) {
    padding: 8px 20px 50px;
  }
`;
